import React, { useEffect, useState } from 'react'
import { Keyboard, KeyboardAvoidingView, ScrollView } from 'react-native'

interface keyboradAvoidViewProps {
  children: React.ReactNode
  exactHeight?: number
  contentContainerClassName?: string
}

const KeyboardAvoidingScrollView = ({
  exactHeight = 1,
  contentContainerClassName,
  children,
}: keyboradAvoidViewProps) => {
  const [isMargin, setIsMargin] = useState<number>(0)
  useEffect(() => {
    const keyboardDidShowListener = Keyboard.addListener(
      'keyboardDidShow',
      (event) => {
        setIsMargin(event.endCoordinates.height)
      }
    )
    const keyboardDidHideListener = Keyboard.addListener(
      'keyboardDidHide',
      () => {
        setIsMargin(0)
      }
    )
    return () => {
      keyboardDidHideListener.remove()
      keyboardDidShowListener.remove()
    }
  }, [])
  return (
    <KeyboardAvoidingView
      className={contentContainerClassName ?? 'bg-white px-3'}
      style={{ flex: 1, marginTop: -(Math.round(isMargin) / exactHeight) }}
    >
      <ScrollView
        contentContainerStyle={{ flex: 1 }}
        keyboardDismissMode="on-drag"
      >
        <>{children}</>
      </ScrollView>
    </KeyboardAvoidingView>
  )
}

export default KeyboardAvoidingScrollView
